import React from 'react';
import { assets } from '../assets/assets';

const AboutCollection = () => {
  return (
    <div className='about-section'>
      {/* <!-- ======================= about start  ============================ --> */}
    <div className="about_sec pt-5 pb-5 mt-3 mb-3">
        <div className="container">
            <div className="row d-flex justify-content-center">
                <div className="col-lg-9 col-lg-6">
                    <div className="row gy-4 gy-lg-0 text-center">
                        <div className="col-6 col-md-3">
                            <div className="about_info">
                                <div className="icon">
                                    <img src={assets.donate_icon} alt="Worth Donations"/>
                                </div>
                                <div className="content">
                                    <h3>100 lakh+</h3>
                                    <p>Worth Donations</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="about_info">
                                <div className="icon">
                                    <img src={assets.mic_icon} alt="Worth Donations"/>
                                </div>
                                <div className="content">
                                    <h3>100+</h3>
                                    <p>Successful Campaigns</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="about_info">
                                <div className="icon">
                                    <img src={assets.unique_icon} alt="Worth Donations"/>
                                </div>
                                <div className="content">
                                    <h3>100 lakh+</h3>
                                    <p>Live Impacted</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="about_info">
                                <div className="icon">
                                    <img src={assets.noun_icon} alt="Worth Donations"/>
                                </div>
                                <div className="content">
                                    <h3>1 lakh+</h3>
                                    <p>Unique Donors</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- ======================= about end  ============================ --> */}
    </div>
  )
}

export default AboutCollection
